import { GuestsVoice } from '@type/buzzkuri/programs-categor'
import React from 'react'
import { GuestsVoicesContentItem } from './Item'

type Props = {
  guestsVoices: GuestsVoice[]
}
export const GuestsVoicesContent = ({ guestsVoices }: Props): JSX.Element => (
  <div className="px-[6.1vw] pt-[8.5vw] lg:pt-[3.6vw] lg:pr-[3.5vw] pb-[10vw] lg:pb-[4.1vw] lg:pl-[1.8vw] bg-[#F7F6F5]">
    {guestsVoices.map((guestsVoice, i) => (
      <div key={i} className="mb-[8vw] last:mb-0 lg:mb-[2.7vw]">
        <GuestsVoicesContentItem {...{ guestsVoice }} />
      </div>
    ))}
  </div>
)
